import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import BookingForm from '../../components/feature/BookingForm';

export default function BookingPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-yellow-400 to-orange-500 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Book Your Desert Adventure
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Ready to experience the magic of the Arabian desert? Choose from our exciting range of safari tours and create unforgettable memories.
            </p>
          </div>
        </section>

        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}